// extracted by mini-css-extract-plugin
export var bg = "hero-module--bg--RwTb2";
export var bounds = "hero-module--bounds--2J1Iu";
export var drag = "hero-module--drag--FJUDd";
export var gui = "hero-module--gui--GMnZt";
export var header = "hero-module--header--OLsHu";
export var shadow = "hero-module--shadow--YCvuq";
export var wrapper = "hero-module--wrapper--QQ8xG";